module.exports = __webpack_public_path__ + "img/for-good-luck.5a663867.svg";